<!-- components/AppNotification.vue -->
<script setup lang="ts">
import { useNotivueKeyboard } from 'notivue'
import { computed } from 'vue'

const props = defineProps({
  item: {
    type: Object,
    required: true
  }
})

const { elementsTabIndex } = useNotivueKeyboard()

const isConfirmDialog = computed(() => props.item.actions?.length > 1)
</script>

<template>
  <div class="Notification" :data-notivue-type="item.type">
    <h3 v-if="item.title" class="Notification__title">{{ item.title }}</h3>
    <p class="Notification__message" :role="item.ariaRole" :aria-live="item.ariaLive">
      {{ item.message }}
    </p>
    
    <nav v-if="item.actions?.length" class="Notification__actions">
      <button
        v-for="(action, index) in item.actions"
        :key="index"
        @click="action.onClick"
        :tabindex="isConfirmDialog ? elementsTabIndex : -1"
        class="Notification__button"
        :class="`Notification__button--${index === 0 ? 'cancel' : 'confirm'}`"
      >
        {{ action.label }}
      </button>
    </nav>
  </div>
</template>

<style scoped>
.Notification {
  padding: 1rem;
  border-radius: 0.5rem;
  background: rgb(251, 188, 188);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  max-width: 400px;
  margin: 0.5rem;
}

.Notification__title {
  font-weight: bold;
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
}

.Notification__message {
  margin-bottom: 1rem;
  color: #333;
}

.Notification__actions {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  margin-top: 1rem;
}

.Notification__button {
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  cursor: pointer;
  border: none;
  transition: all 0.2s ease;
  font-weight: 500;
}

.Notification__button--cancel {
  background-color: #f3f4f6;
  color: #333;
}

.Notification__button--cancel:hover {
  background-color: #e5e7eb;
}

.Notification__button--confirm {
  background-color: #f6006a;
  color: #f3f4f6;
}

.Notification__button--confirm:hover {
  background-color: #fb519b;
}

/* Focus styles */
[data-notivue-container]:focus-visible .Notification {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}

.Notification__button:focus-visible {
  outline: 2px solid #3b82f6;
  outline-offset: 2px;
}
</style>